module.exports = __webpack_public_path__ + "7b43b87cea0f54f0d830d3b34cd4b882.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/pansy.jpg
 ** module id = 198
 ** module chunks = 0
 **/